import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatDrawer } from "@angular/material/sidenav";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/core/services/common.service";
import { PermissionService } from "src/app/core/services/permisson.service";
import { handleHeaderClick } from "src/app/shared/utils/commonUtils";
import { ActionPreviewComponent } from "src/app/shared/components/action-preview/action-preview.component";
import { TdspConversionPixelService } from "src/app/core/services/tdsp/tdsp-conversion-pixel.service";
import { TdspGetPixelTagComponent } from "../../tdsp-segment/tdsp-get-pixel-tag/tdsp-get-pixel-tag.component";
import { ConvertionPixelExportComponent } from "src/app/resources/libraries/conversion-pixel/convertion-pixel-export/convertion-pixel-export.component";
import { NotificationService } from "src/app/notification.service";

@Component({
  selector: "app-tdsp-conversion-pixel-landing",
  templateUrl: "./tdsp-conversion-pixel-landing.component.html",
  styleUrl: "./tdsp-conversion-pixel-landing.component.scss",
})
export class TdspConversionPixelLandingComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatMenuTrigger) columnMenutrigger: MatMenuTrigger;
  @ViewChild("drawer") drawer: MatDrawer;

  columns: string[] = ["checkbox", "name", "id", "modified_at", "last_hit_at", "action"];
  displayedColumns;
  columnOptions: Array<any> = [
    { value: "checkbox", label: "Checkbox", disable: false },
    { value: "name", label: "Name", disable: false },
    { value: "id", label: "ID", disable: false },
    { label: "Last Modified", value: "modified_at", disable: false },
    { label: "Last Fire", value: "last_hit_at", disable: false },
    { value: "action", label: "Action", disable: true },
  ];

  pageLength;
  pageSize: number;
  pageIndex: number;
  public allSelectedPixels: boolean = false;
  selectedState = "all";
  userRole;
  dateRange: Array<any> = [];
  showSearchInput: boolean = false;

  allPixels: Array<any> = [];
  advertiserId = null;
  agcAdvId = null;
  globalParams = {};
  numberOfFiltersApplied: number = 0;
  hideFilterBadge: boolean = true;

  createPermission: boolean = false;
  editPermission: boolean = false;
  viewPermission: boolean = false;
  deletePermission: boolean = false;

  filterJSON = {};
  searchParams = {};
  filterType: "agency_advertiser_filters" | "advertiser_filters";
  createPath: string;
  filterName: string;
  expandedElement;

  readonly dspType: string;
  readonly entityType: string;
  readonly path: string;

  constructor(
    public commonService: CommonService,
    public dialog: MatDialog,
    private permissionService: PermissionService,
    private activatedRoute: ActivatedRoute,
    private conversionPixelService: TdspConversionPixelService,
     private toastr: NotificationService,
  ) {
    this.dspType = "tdsp";
    this.entityType = "pixel";
    this.path = "tdsp/conversion-pixel";
  }

  ngOnInit(): void {
    this.createPath = "/tdsp/conversion-pixel/create";
    this.filterName = "tdspPixel";
    this.displayedColumns = this.columns;
    this.userRole = localStorage.getItem("role");

    this.commonService.setIdsFromParams(
      this.activatedRoute.snapshot.queryParamMap,
      this
    );

    this.commonService.setMenuFlag(
      "advertiser_menu",
      "tdsp_libraries",
      "tdsp_pixel",
      "tdsp",
      "all"
    );

    if (this.agcAdvId) {
      this.globalParams["agency_advertiser_id"] = this.agcAdvId;
      this.filterType = "agency_advertiser_filters";
    }
    if (this.advertiserId) {
      this.globalParams["advertiser_id"] = this.advertiserId;
      this.filterType = "advertiser_filters";
    }

    this.createPermission =
      this.permissionService.getCreatePermissions("pixel");
    this.viewPermission = this.permissionService.getViewPermissions("pixel");
    this.editPermission = this.permissionService.getEditPermissions("pixel");
    this.deletePermission =
      this.permissionService.getDeletePermissions("pixel");
    this.filterTable(false);
  }

  onHeaderClick(event: MouseEvent) {
    handleHeaderClick(event, this.sort);
  }

  updateTable() {
    this.dataSource = new MatTableDataSource(this.allPixels);
    this.pageSize = this.paginator.pageSize;
    this.pageIndex = this.paginator.pageIndex;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource._updatePaginator(this.pageLength);
  }

  getAllPixels(params = {}, merge = false) {
    params = { ...params, ...this.globalParams };
    this.conversionPixelService.list(params).subscribe((res) => {
      if (merge) {
        this.allPixels = this.allPixels.concat(
          res.data.map((e) => ({
            ...e,
            selected: false,
          }))
        );
        this.updateTable();
      } else {
        this.allPixels = res.data.map((e) => ({
          ...e,
          selected: false,
        }));
        this.pageLength = res.count;
        this.updateTable();
      }
    });
  }

  createFilter() {
    const params = {};
    this.hideFilterBadge = true;
    this.numberOfFiltersApplied = 0;

    if (this.selectedState && this.selectedState !== "all") {
      params["state"] = this.selectedState;
      this.hideFilterBadge = false;
      this.numberOfFiltersApplied += 1;
    }
    return params;
  }

  toggleFilterDrawer(resetFlag = false) {
    if (this.numberOfFiltersApplied == 0) {
      this.hideFilterBadge = true;
    }
    if (resetFlag) {
      this.selectedState = "all";
      this.hideFilterBadge = true;
      this.numberOfFiltersApplied = 0;
      this.commonService.setFilterJSONValues(
        this.filterType,
        this.filterName,
        this
      );
      this.filterTable(false);
    }
    this.drawer.toggle();
  }

  filterTable(toggle: boolean = true, params = {}, merge = false) {
    params = { ...this.createFilter(), ...this.searchParams, ...params };
    this.commonService.setFilterJSONValues(
      this.filterType,
      this.filterName,
      this
    );
    if (toggle) this.toggleFilterDrawer();
    this.getAllPixels(params, merge);
  }

  searchPixel(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length >= 3) {
      this.searchParams["search_term"] = filterValue;
      this.filterTable(false, this.searchParams);
    }
    if (filterValue.length == 0) {
      this.searchParams = {};
      this.filterTable(false);
    }
  }

  handlePageEvent(event: PageEvent) {
    this.pageLength = event.length;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getAllPixels();
    let requested_page = event.pageSize * (event.pageIndex + 1);
    if (requested_page > this.allPixels.length) {
      let params = {
        start_element: this.allPixels.length,
        num_elements: 100,
      };
      this.filterTable(false, params, true);
    }
  }

  closeSelectionList() {
    this.columnMenutrigger.closeMenu();
    this.displayedColumns = this.columns;
  }

  getAllSelectedPixels() {
    this.allSelectedPixels = this.commonService.getAllCheckboxSelected(
      this.allPixels,
      this.pageIndex,
      this.pageSize
    );
  }

  isPixelSelected(): boolean {
    if (this.allPixels == null) {
      return false;
    }
    return this.commonService.isCheckboxIntermediate(
      this.allPixels,
      this.pageSize,
      this.pageIndex,
      this.allSelectedPixels
    );
  }

  selectAllPixels(checked: boolean) {
    this.allSelectedPixels = checked;
    if (this.allPixels == null) {
      return;
    }
    this.allPixels = this.commonService.selectAllCheckbox(
      this.allPixels,
      this.pageIndex,
      this.pageSize,
      checked
    );
  }

  getSelectedPixels() {
    this.allSelectedPixels =
      this.allPixels != null && this.allPixels.every((e) => e.selected);
  }

  async getDataAndWait(request) {
    return await request.toPromise();
  }

  deletePixels(selected_pixel_ids) {
    selected_pixel_ids.forEach((id) => {
      this.getDataAndWait(
        this.conversionPixelService.destroy(id, this.globalParams)
      ).then(() => {
        this.allPixels = this.allPixels.filter((e) => e.id != id);
        this.pageLength -= 1;
        this.updateTable();
      });
    });
  }

  previewAction(message, selected_items, action = "delete") {
    let dialogRef = this.dialog.open(ActionPreviewComponent, {
      width: "25%",
      disableClose: true,
      autoFocus: false,
      panelClass: "actionpreview-modalbox",
      data: { action: message, items: selected_items.length },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.save) {
        if (action == "delete") {
          this.deletePixels(selected_items.map((ele) => ele.id));
        }
      } else {
        this.allPixels.map((ele) => (ele.selected = false));
        this.allSelectedPixels = false;
      }
    });
  }

  openPopUp(pixelId) {
    let dialogRef = this.dialog.open(TdspGetPixelTagComponent, {
      width: "50%",
      disableClose: true,
      autoFocus: false,
      data: {
        pixelId: pixelId,
        globalParams: this.globalParams,
        type: "conversion-pixel",
      },
    });
  }

  getSelectedPixelIds(): number[] {
  return this.allPixels
    .filter(pixel => pixel.selected)
    .map(pixel => pixel.id);
}

openBulkGetTag() {
  const selectedIds = this.getSelectedPixelIds();

  if (!selectedIds.length) {
    this.toastr.warning("Please select at least one pixel");
    return;
  }

  this.dialog.open(TdspGetPixelTagComponent, {
    width: "60%",
    disableClose: true,
    autoFocus: false,
    data: {
      pixelIds: selectedIds,
      globalParams: this.globalParams,
      type: "conversion-pixel",
      isBulk: true
    }
  });
}

}
